export { default as Vega } from './Vega';
export { default as VegaLite } from './VegaLite';
export { default as createClassFromSpec } from './createClassFromSpec'; // Export types

export * from './types';